"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoiceCallQueueFailExitReasonEnum = void 0;
var VoiceCallQueueFailExitReasonEnum;
(function (VoiceCallQueueFailExitReasonEnum) {
    VoiceCallQueueFailExitReasonEnum["TIMEOUT"] = "TIMEOUT";
    VoiceCallQueueFailExitReasonEnum["FULL"] = "FULL";
    VoiceCallQueueFailExitReasonEnum["JOINEMPTY"] = "JOINEMPTY";
    VoiceCallQueueFailExitReasonEnum["LEAVEEMPTY"] = "LEAVEEMPTY";
    VoiceCallQueueFailExitReasonEnum["JOINUNAVAIL"] = "JOINUNAVAIL";
    VoiceCallQueueFailExitReasonEnum["LEAVEUNAVAIL"] = "LEAVEUNAVAIL";
})(VoiceCallQueueFailExitReasonEnum = exports.VoiceCallQueueFailExitReasonEnum || (exports.VoiceCallQueueFailExitReasonEnum = {}));
